import { createContext, useContext, type ReactNode } from "react";
import { useTelemetry } from "../hooks/useTelemetry";
import type { TelemetryValue, GpsData, DtcEntry, MqttConnectionStatus } from "../types/telemetry";
import type { CalibrationEntry } from "../types/config";

interface TelemetryContextValue {
  metrics: Map<string, TelemetryValue>;
  gps: GpsData;
  trail: [number, number][];
  dtcs: DtcEntry[];
  connectionStatus: MqttConnectionStatus;
  publish: (topic: string, payload: string) => boolean;
}

const TelemetryContext = createContext<TelemetryContextValue | null>(null);

export function TelemetryProvider({
  topicPrefix,
  calibration,
  children,
}: {
  topicPrefix: string;
  calibration?: CalibrationEntry[];
  children: ReactNode;
}) {
  const telemetry = useTelemetry(topicPrefix, calibration);
  return (
    <TelemetryContext.Provider value={telemetry}>
      {children}
    </TelemetryContext.Provider>
  );
}

export function useTelemetryContext(): TelemetryContextValue {
  const ctx = useContext(TelemetryContext);
  if (!ctx) {
    throw new Error(
      "useTelemetryContext must be used within a TelemetryProvider",
    );
  }
  return ctx;
}
